<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="21" height="21" rx="3.5" fill="#0033A1" stroke="#012D96"/>
<path d="M7 13L10 16L17 9" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>
